export const environment = {
  production: false,
  apiUrl: 'https://devbaiterek.idet.kz/objects-hgf-back/',
  apiWidget: 'https://devbaiterek.idet.kz/widgets-back/',
  apiWidgetConstructor: 'https://devbaiterek.idet.kz/widgets-constructor-back/',
  apiMioBack: 'https://devbaiterek.idet.kz/mio-back/',
};
